// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3Or3O","left":"InfoRow_left__2w7s2"};